<template>
    <v-container>
        <div class="warning-info">
            <v-icon>info</v-icon>
            <span>提示：首次投保时被保险人年龄为18-65周岁{{ code === 2016 ? '，连续投保可至70周岁' : '' }}</span>
        </div>
        <div class="warning-table">
            <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                    hide-actions
            >
                <template v-slot:headers="props">
                    <tr>
                        <th class="text-xs-left table-border-right table-border-top">
                            {{ props.headers[0]['text']}}
                        </th>
                        <th class="text-xs-left table-border-right table-border-top">
                            {{ props.headers[1]['text']}}
                        </th>
                        <th class="text-xs-left table-border-top">
                            {{ props.headers[2]['text']}}
                        </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <td class="text-xs-left table-border-right">{{ props.item.name }}</td>
                    <td class="text-xs-left table-border-right">{{ props.item.idNumber }}</td>
                    <td class="text-xs-left">{{ props.item.professionName }}</td>
                </template>
            </v-data-table>
        </div>
        <div class="warning-footer">
            <span>
                本次投保人员中含有65岁以上人数： {{ count }}人（如为连续投保业务，可忽略）
                <div class="warning-footer-download">
                    <excel-export :sheet="sheet" filename="本次投保人员中含有65岁以上人员清单">
                        <span class="warning-export">导出人员清单</span>
                    </excel-export>
                </div>
            </span>
        </div>
    </v-container>
</template>

<script>
    // import {ExcelExport} from 'pikaz-excel-js'
    export default {
        components:{
            // ExcelExport,
        },
        props: {
            data: Array,
            code: Number,
        },
        data(){
            return {
                headers: [
                    {text: "姓名", value: "name"},
                    {text: "身份证号", value: "idNumber"},
                    {text: "职业类别", value: "professionName"},
                ],
                count:0,
                sheet:[]
            }
        },
        computed:{
            desserts(){
                let table = this.data.map(info => {
                    return {
                        name: info.name,
                        idNumber: info.idNumber,
                        professionName: info.professionName,
                    }
                });
                let tHeader = ["姓名", "身份证号", "职业类别"];
                let keys = ["name","idNumber", "professionName"];
                this.sheet = [
                    {
                        table: table,
                        tHeader: tHeader,
                        keys: keys,
                        title: "本次投保人员中含有65岁以上人员清单"
                    }
                ];
                this.count = table.length
                return table;
            }
        }
    }
</script>

<style lang="scss" scoped>
    div.warning-info{
        background-color: #fffbe6;
        border: 1px solid #ffe58f;
        border-radius: 5px;
        height: 33px;
        line-height: 30px;
        margin-bottom: 20px;
        padding-left: 10px;
        span{
            font-size: 12px;
            color: rgba(0,0,0,0.54);
        }
        i{
            color: #faad14;
            margin-right: 10px;
            font-size: 17px;
        }
    }
    div.warning-table{
        margin-bottom: 10px;
        font-size: 12px;
        th{
            font-weight: bold;
            color: #000;
        }
        .table-border-right{
            border-right: 1px solid #dfe6ec;
        }
        .table-border-top{
            border-top: 1px solid #dfe6ec;
        }
    }
    div.warning-footer{
        position: relative;
        margin-top: 10px;
        font-size: 12px;
        span.warning-export{
            color: #dd122a;
            margin-left: 10px;
            text-decoration:underline;
            cursor: pointer;
        }
        .warning-footer-download{
            position: absolute;
            left: 400px;
            top: 0;
        }
    }
</style>
